export default {"src":"/_next/static/media/icon_02.5db9b17b.svg","height":44,"width":44};